import { useQuery } from 'react-query'

import useCartStore from '@/store/slices/cart'

import { getBestsellerProducts } from './getBestsellerProducts'
import { sendCartProductIds } from './sendCartProductIds'

export function useSimilarProducts() {
  const cart = useCartStore((state) => state.products)

  return useQuery(
    ['similar_products', cart.map((item) => item.id)],
    async () => {
      const productsIds = await sendCartProductIds(cart)
      return getBestsellerProducts(productsIds.content.ids)
    }
  )
}
